import type React from 'react';

import {
  LabelField,
  OrdReferenceArrayInput,
  OrdEditableDatagrid,
  useOrdForm,
  OrdList,
} from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';
import { RowForm, EditRowButton } from '@ratto-components/ra-editable-datagrid';
import { TextField } from 'react-admin';

import type { OrdListProps } from '@ragu-components/ord-components';

export const AssignedResourceList = (props: Omit<OrdListProps, 'children'>): React.ReactElement => (
  <OrdList sort={{ field: 'name', order: 'ASC' }} {...props}>
    <OrdEditableDatagrid
      editForm={<EditForm />}
      actions={<EditRowButton />}
      bulkActionButtons={false}
      sx={{ '& .column-undefined': { textAlign: 'end' } }}
    >
      <TextField source='name' />
      <TextField source='description' />
      <LabelField />
    </OrdEditableDatagrid>
  </OrdList>
);

const EditForm = (): React.ReactElement => {
  const props = useOrdForm({
    sanitizeFields: ['labels'],
    replaceRelationships: ['labels'],
  });
  return (
    <RowForm {...props}>
      <TextField source='name' />
      <TextField source='description' />
      <OrdReferenceArrayInput
        resource={Resources.labels}
        source={Resources.labels}
        helperText={false}
        label={false}
        TextFieldProps={{
          InputLabelProps: { shrink: false },
        }}
      />
    </RowForm>
  );
};
